import { StyleSheet, Font } from '@react-pdf/renderer';
import RobotoRegular from '../../../../lib/fonts/Roboto-Regular.ttf';
import RobotoBold from '../../../../lib/fonts/Roboto-Bold.ttf';

// Registre a fonte Roboto
Font.register({
    family: 'Roboto',
    fonts: [
        { src: RobotoRegular, fontStyle: 'normal', fontWeight: 'normal' },
        { src: RobotoBold, fontStyle: 'normal', fontWeight: 'bold' },
    ],
});

export const styles = StyleSheet.create({
    page: {
		flexDirection: 'column',
		backgroundColor: '#FFFFFF',
		padding: 20,
    },
    viewRow: {
		flexDirection: 'row',
		alignItems: 'center',
		marginBottom: 20,
    },
    viewRowFinal: {
		flexDirection: 'row',
		alignItems: 'center',
    },
    viewImagem: {
		width: '15%'
    },
    viewEmpresa: {
		width: '70%',
		marginRight: '5%'
    },
    viewPedido: {
		width: '15%',
    },
    logo: {
		width: 100,
		height: 75,
    },
	normalText: {
        fontSize: 10, // ou qualquer outro tamanho desejado
        fontFamily: 'Roboto',
		fontWeight: 'normal',
        marginVertical: 2, // margem vertical em torno do texto
		textAlign: 'justify'
    },
	normalTextLI: {
        fontSize: 10, // ou qualquer outro tamanho desejado
        fontFamily: 'Roboto',
		fontWeight: 'normal',
        marginVertical: 2, // margem vertical em torno do texto
		paddingLeft: 5
    },
	boldTextH2: {
		fontSize: 18, // Tamanho típico de um cabeçalho de segundo nível (H2)
		fontFamily: 'Roboto',
		fontWeight: 'bold',
		marginVertical: 8, // Margem vertical um pouco maior para separar o cabeçalho do conteúdo adjacente
	},
    boldTextH4: {
		fontSize: 14, // Tamanho típico de um cabeçalho de segundo nível (H2)
		fontFamily: 'Roboto',
		fontWeight: 'bold',
		marginVertical: 6, // Margem vertical um pouco maior para separar o cabeçalho do conteúdo adjacente
	},
	boldText: {
        fontSize: 10, // ou qualquer outro tamanho desejado
        fontFamily: 'Roboto',
        fontWeight: 'bold',
        marginVertical: 2, // margem vertical em torno do texto
    },
	viewFornecedor: {
		width: '70%',
		marginBottom: 8,
	},
    dividerHeader: {
    	borderBottom: '1px solid #000000',
    	justifyContent: "center",
		verticalAlign: "middle",
		margin: "5px 0px"
    },
    divider: {
      borderBottom: '1px solid #000000',
      marginBottom: 20,
    },
    listItem: {
      marginBottom: 10,
    },
    table: {
        width: '100%',
        borderTop: '1px solid #000000',
        borderLeft: '1px solid #000000',
        borderRight: '1px solid #000000',		
	},
	tableRow: {
		flexDirection: 'row',
	},
	celulaBorderBold: {
		backgroundColor: '#CCCCCC',
		borderRight: '1px solid #000000',
		fontSize: 10, // ou qualquer outro tamanho desejado
		fontFamily: 'Roboto',
		fontWeight: 'bold',
		padding: 5,
		borderTopWidth: 1,
	},
	celulaNoBorder: {
		padding: 5,
		fontSize: 8, // ou qualquer outro tamanho desejado
		fontFamily: 'Roboto',
		borderRight: '1px solid #000000',
		borderTopWidth: 1,
	},
	celulaBorder: {
		padding: 5,
		fontSize: 8, // ou qualquer outro tamanho desejado
		fontFamily: 'Roboto',
		borderBottom: '1px solid #000000',
		borderRight: '1px solid #000000',
		borderTopWidth: 1,
	},
  });